import { render, staticRenderFns } from "./ReportMain.vue?vue&type=template&id=67d5a65a&"
import script from "./ReportMain.vue?vue&type=script&lang=js&"
export * from "./ReportMain.vue?vue&type=script&lang=js&"
import style0 from "./ReportMain.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports